import headMeta from '@/constants/headMeta';
import PropertyPathHelper from '@/utils/PropertyPathHelper';
import ListingMixin from '@/components/page-specific/listing/mixins/listing';
import ListingMetaHelper from '@/components/page-specific/listing/mixins/helpers/ListingMetaHelper';

const SOLD_PRICE = 'sign up to see sold price';

// @vue/component
const SoldPropertyHeadMixin = {
  mixins: [ListingMixin],
  head() {
    return this.headOG;
  },
  computed: {
    headOG() {
      return {
        title: this.pageTitle,
        meta: [
          { hid: 'description', name: 'description', content: this.pageDescription },
          { property: 'og:title', content: this.pageTitle },
          { property: 'og:description', content: this.pageDescription },
          { property: 'og:image', content: this.pageImage },
          { property: 'og:url', content: `${headMeta.domain}${PropertyPathHelper.generateSoldRouteFromListing(this.listing)}` },
          { property: 'og:site_name', content: headMeta.siteName },
          { property: 'og:type', content: headMeta.type },
        ],
      };
    },
    pageTitle() {
      return ListingMetaHelper.getPageTitle(this.listing);
    },
    pageDescription() {
      return ListingMetaHelper.buildDescription([
        ListingMetaHelper.PAGE_INTRODUCTION,
        this.soldPropertyPrefix,
        ListingMetaHelper.getPropertyDescription(this.listing.buildingClass),
        ListingMetaHelper.getCommunityAndCityDescription(this.listing),
        ListingMetaHelper.getListingSizeDescription(this.listing, SOLD_PRICE),
      ]);
    },
    pageImage() {
      return ListingMetaHelper.getMainImage(this.listing);
    },
    soldPropertyPrefix() {
      return this.listing.isBode
        ? 'This listing was sold without an agent.'
        : 'View this sold listing.';
    },
  },
};

export default SoldPropertyHeadMixin;
